import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/home/index.vue";
import Categories from "../views/categories/index.vue";
import MaterialList from "../views/material-list/index.vue";

// 处理重复加载路由导致的冗余报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

Vue.use(VueRouter);
const routes = [
    {
        path: "/",
        name: "home",
        component: MaterialList
    },
    {
        //  首页
        path: "/dist",
        redirect: "/" //路由重定向
    },
    {
        //  首页
        path: "/home",
        redirect: "/" //路由重定向
    },
    {
        path: "/search",
        name: "search",
        component: MaterialList
    },
    {
        path: "/:categories",
        name: "Categories",
        component: MaterialList
    },
    {
        path: "/:categories/:materialList",
        name: "MaterialList",
        component: MaterialList
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
});

export default router;
